import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

(function () {
	const swipers = document.querySelectorAll('.swiper:not(.swiper-thumbs)');

	for (let i = 0; i < swipers.length; i++) {
		const root = swipers[i];
		root.classList.add('swiper-main-' + i);

		// Make the carousel focusable for keyboard users
		root.tabIndex = 0;
		root.setAttribute('role', 'region');
		root.setAttribute('aria-roledescription', 'carousel');

		if (!root.getAttribute('aria-label') && !root.getAttribute('aria-labelledby')) {
			root.setAttribute('aria-label', 'Image carousel');
		}

		// Nav buttons (only exist if JS loads)
		const prev = document.createElement('button');
		prev.type = 'button';
		prev.className = 'swiper-button-prev';
		prev.setAttribute('aria-label', 'Previous slide');

		const next = document.createElement('button');
		next.type = 'button';
		next.className = 'swiper-button-next';
		next.setAttribute('aria-label', 'Next slide');

		root.appendChild(prev);
		root.appendChild(next);

		[prev, next].forEach((button) => {
			button.addEventListener('keydown', (e) => {
				if (e.key === ' ' || e.key === 'Spacebar') {
					e.preventDefault();
					button.click();
				}
			});
		});

		const thumbs = document.createElement('div');
		thumbs.classList.add('swiper', 'swiper-thumbs', 'swiper-thumbs-' + i);

		const wrapper = root.querySelector('.swiper-wrapper');
		if (wrapper) thumbs.appendChild(wrapper.cloneNode(true));
		thumbs.querySelectorAll('.img-text-cont').forEach(e => e.remove()); // don't copy over img-text to thumbs

		root.after(thumbs);

		const thumbsSwiper = new Swiper('.swiper-thumbs-' + i, {
			spaceBetween: 10,
			rewind: true,
			slidesPerView: 3.5,
			freeMode: true,
			watchSlidesProgress: true,
			breakpoints: {
				0: { slidesPerView: 2.5, spaceBetween: 8 },
				560: { slidesPerView: 3, spaceBetween: 10 },
				768: { slidesPerView: 4, spaceBetween: 10 },
			},
		});

		const swiper = new Swiper('.swiper-main-' + i, {
			spaceBetween: 10,
			rewind: true,
			navigation: { nextEl: next, prevEl: prev },
			thumbs: { swiper: thumbsSwiper },
			a11y: { enabled: true },
			on: {
				init() {
					const total = this.slides.length;
					this.slides.forEach((slideEl, idx) => {
						slideEl.setAttribute('role', 'group');
						slideEl.setAttribute('aria-roledescription', 'slide');
						slideEl.setAttribute('aria-label', `Slide ${idx + 1} of ${total}`);
					});
				},
			},
		});

		// Enable keyboard only when focus is within the carousel
		// swiper.keyboard.enable normally works also if the swiper is NOT in focus, so need to disable when not in focus
		root.addEventListener('focusin', () => swiper.keyboard.enable());
		root.addEventListener('focusout', (e) => {
			if (!root.contains(e.relatedTarget)) swiper.keyboard.disable();
		});

		// Image text handler
		root.querySelectorAll('.swiper-slide').forEach(slide => {
			let textContainer = slide.querySelector('.img-text-cont');
			if (textContainer && textContainer.textContent) {
				if (!textContainer.textContent.trim())
					textContainer.remove();
				else {
					slide.style.setProperty('--img-prop', slide.querySelector('img').naturalWidth / slide.querySelector('img').naturalHeight);
				}
			}
		})
	}
})();
